var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"adds"}},[_c('div',{attrs:{"id":"addsLeft"}},[_c('vueDrag',{ref:"vueDrag"})],1),_vm._v(" "),_c('div',{attrs:{"id":"addsRight"}},[_c('comMap',{ref:"map"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d282502","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paisong/adds.vue
// module id = null
// module chunks = 